import React from "react";
import { Button } from "@/components/ui/button";
import { CheckCircle, Plus } from "lucide-react";

interface EmptyValidationRulesStateProps {
  onCreateDraftRule: () => void;
  isSaving: boolean;
}

export const EmptyValidationRulesState: React.FC<EmptyValidationRulesStateProps> = ({
  onCreateDraftRule,
  isSaving
}) => {
  return (
    <div className="text-center py-12">
      <CheckCircle className="h-16 w-16 mx-auto mb-6 text-muted-foreground/50" />
      <h3 className="text-xl font-semibold mb-3">No validation rules configured</h3>
      <p className="text-muted-foreground mb-6 max-w-md mx-auto">
        There are no validation rules set up for this fund yet. Create your first rule to get started.
      </p>
      <Button
        onClick={onCreateDraftRule}
        disabled={isSaving}
        size="lg"
        className="flex items-center gap-2"
      >
        <Plus className="h-5 w-5" />
        Create First Rule
      </Button>
    </div>
  );
}; 